var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-menu-edit"},[_vm._v("编辑菜单")])
}
var staticRenderFns = []

export { render, staticRenderFns }